export const environment = {
    production: false,
    development: true,
    staging: false,
    host: 'https://dev.se2.tech',
    creatoradminApi: 'https://dev.creatoradmin.spooorts.de/',
    loginApi: 'https://dev.login.spooorts.de/login/',
    // Stripe endpoints live here — see stripe-backend.instructions.md
    backofficeApi: 'https://dev.backoffice.spooorts.de',
    // Stripe sandbox publishable key — fill in your pk_test_... from Stripe Dashboard
    stripePublishableKey: 'pk_test_51TOfqQEXS8bUsCDLbdgPDkhPLuq2zbrsGWCIDqcCViyK9nNCLDrCTOwSTbjlddaIV0QUglawuPhsVenQsATv5qAP00HEqr5iO2',
};